<style lang="less" scoped>
  .legalPerson {
    width: 100%;
    min-height: 100%;
    background-color: #f0f2f6;
    .protocolText {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: #fff;
      overflow-y: auto;
      padding: 0.466667rem 0.666667rem;
      box-sizing: border-box;
      line-height: 0.6rem;
      z-index: 9999;
      text-align: left;
      color: #333333;
      .title {
        font-size: 36px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        line-height: 54px;
        text-align: center;
      }
      .name {
        font-size: 30px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        line-height: 90px;
      }
      .haveRead {
        width: 70%;
        margin: 0 auto;
        margin-top: 30px;
        height: 90px;
        line-height: 90px;
        text-align: center;
        font-size: 36px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #fff;
        background-color: #53b7f6;
      }
    }
    .roof {
      width: 100%;
      height: 100px;
      line-height: 100px;
      text-align: left;
      padding-left: 20px;
      box-sizing: border-box;
      background-color: #21aaff;
      font-size: 30px;
      color: #fff;
      display: flex;
      align-items: center;
      svg {
        margin-right: 20px;
      }
    }
    .header {
      width: 100%;
      background: url("data:image/png;base64,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");
      background-size: 100% 100%;
      .tabs {
        width: 692px;
        height: 153px;
        margin: 0 auto;
        border-radius: 20px;
        display: flex;
        .item {
          flex: 1;
          text-align: center;
          font-size: 26px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          padding-top: 35px;
          box-sizing: border-box;
          position: relative;
          img {
            width: 52px;
            height: 52px;
          }
          .jiantou {
            width: 15px;
            height: 26px;
            position: absolute;
            right: 0;
            bottom: 30px;
          }
        }
        .item:first-child {
          color: #21aaff;
        }
      }
    }
    .tabOne {
      position: relative;
      width: 100%;
      height: 100%;
      .idCard {
        width: 692px;
        margin: 0px auto;
        padding: 40px;
        box-sizing: border-box;
        border-radius: 20px;
        .name {
          width: 100%;
          text-align: center;
          font-size: 30px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
        }
        .idcodeimg {
          width: 561px;
          margin: 0 auto;
          margin-top: 27px;
          overflow: hidden;
          .codeleft {
            float: left;
            width: 267px;
            height: 167px;
            border-radius: 10px;
            border: 1px solid rgba(33, 170, 255, 1);
          }
          .coderight {
            float: right;
            width: 267px;
            height: 167px;
            border-radius: 10px;
            border: 1px solid rgba(33, 170, 255, 1);
          }
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .main {
        width: 692px;
        margin: 0 auto;
        margin-top: 30px;
        border-radius: 20px;
        padding: 35px;
        padding-bottom: 0px;
        box-sizing: border-box;
        background-color: #fff;
        .tip {
          font-size: 26px;
          padding: 10px 0px 0px 20px;
          color: red;
        }
        .name {
          font-size: 30px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
        }
        .items {
          width: 525px;
          margin: 30px auto;
          display: flex;
          font-size: 22px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          div {
            flex: 1;
            text-align: center;
            img {
              width: 113px;
              height: 90px;
              margin-bottom: 20px;
              // border: 1px solid #ccc;
            }
            div {
              display: flex;
              align-items: center;
              justify-content: center;
              i {
                margin-right: 10px;
              }
            }
          }
        }

        .arguments {
          color: #a2a2a2;
          font-size: 1.08em;
          text-align: center;
          padding: 20px;
          border-top: 1px solid rgba(219, 219, 219, 1);
          .input_check{
            vertical-align: middle;
          }
          a {
            color: #3083ff;
          }
        }
        .main-input {
          width: 100%;
          height: 150px;
          line-height: 87px;
          font-size: 28px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          padding-top: 5px;
          a {
            color: #3083ff;
          }
        }
      }
    }
    .nextStep {
      width: 9.093333rem;
      height: 1.253333rem;
      margin: 0 auto;
      padding-top: 40px;
      .qian{
        width: 100%;
        height: 100px;
        background: #00a9ff;
        border-radius: 60px;
        text-align: center;
        line-height: 100px;
        color: #ffffff;
        font-size: 4.4vw;
      }
    }
    .nextStep .legalPerson .nut-button.block {
      height: 13.333333vw !important;
    }
  }
</style>

<style>
  .legalPerson .codeleft .nut-imagepicker .img-list .add-icon {
    width: 267px;
    height: 167px;
    position: relative;
    border: none;
    background: url("https://gsb-zc.oss-cn-beijing.aliyuncs.com//zc_383515910831670212020215324721idCodez.png")
    no-repeat;
    background-size: 100% 100%;
  }
  .legalPerson .coderight .nut-imagepicker .img-list .add-icon {
    width: 267px;
    height: 167px;
    position: relative;
    border: none;
    background: url("https://gsb-zc.oss-cn-beijing.aliyuncs.com//zc_1585159108359080520202153950805idCodeb.png")
    no-repeat;
    background-size: 100% 100%;
  }
  .legalPerson .nut-imagepicker .img-list .img-item a img {
    display: inline-block;
    width: 267px;
    height: 167px;
  }
  .legalPerson .nut-imagepicker .img-list .add-icon i {
    display: none;
  }
  .legalPerson .nut-button.block {
    height: 70px !important;
    font-size: 30px !important;
    background: #21aaff;
  }
  .legalPerson .nut-button[disabled] {
    background: #dadada !important;
    color: #f6f6f6 !important;
  }
  .legalPerson .nut-textinput input {
    height: 80px !important;
    width: 430px !important;
  }
  .legalPerson .nut-textinput-label {
    font-size: 28px !important;
  }
  .legalPerson .nut-checkbox input:checked {
    background-color: #21aaff !important;
    border-color: #21aaff !important;
  }
  .legalPerson .nut-button[disabled] {
    background: #dadada !important;
    color: #f6f6f6 !important;
  }
  .legalPerson .nut-checkbox input {
    background: #ddd;
    width: 30px !important;
    height: 30px !important;
  }
  /* .legalPerson .nut-checkbox.nut-checkbox-size-base input {
    width: 30px !important;
    height: 30px !important;
  }

  .legalPerson .nut-checkbox input {
    border-color:red !important;
  } */
</style>
<template>
  <div class="legalPerson">
    <div class="tabOne">
      <div class="idCard">
        <div class="name">- {{agreementName}} -</div>
      </div>
      <div class="main">
        <div class="main-input" style="margin-top: 17px;">
          <nut-textinput style="padding-left: 0.7rem"
                         v-model="userInfo.userName"
                         label="姓名："
                         placeholder="请填写真实姓名"
                         :clearBtn="true" />
        </div>

        <div class="main-input">
          <nut-textinput v-model="userInfo.idNo"
                         label="身份证号："
                         placeholder="请填写身份证号"
                         :clearBtn="true" />
        </div>
<!--        <div class="main-input">-->
<!--          <nut-textinput v-model="userInfo.mobile"-->
<!--                         maxlength="11"-->
<!--                         style="padding-left: 0.4rem"-->
<!--                         label="手机号： "-->
<!--                         placeholder="请填写实名手机号"-->
<!--                         :clearBtn="true"/>-->
<!--        </div>-->
      </div>
    </div>

    <div class="nextStep">
      <div class="qian" @click="nextStep" :loading="loading">立即签署</div>
    </div>
  </div>

</template>
<script>
  import http from '../../../api'
  import config from '../../../utils/config.js'
  import {getUrlKey} from '../../../utils'
  import sign from './sign'

  export default {
    data () {
      return {
        userInfo: {},
        agreementName: "班委合作协议",
        loading: false,
        disabled: false,
        forbiddenMsg: "",
        paramInfo: {
          configId: '',
          appId: '',
          nonceStr: '',
          sign: '',
        },
      }
    },
    created () {
      let path = window.location.href.split('?') //分割url
      console.log('-------------curlpath-------------', path, '')
      // console.log(path, "测试截取Url");
      if (path[1]) {
        let href = path[0] + '?' + path[1]
        // console.log(href, "herif测试四");
        this.paramInfo.appId = getUrlKey('appId', href)
        this.paramInfo.nonceStr = getUrlKey('nonceStr', href)
        this.paramInfo.sign = getUrlKey('sign', href)

        this.paramInfo.configId = getUrlKey('cfg', href)
        this.validParams();
      } else {
        this.$toast.fail('签约地址错误，请重新打开')
      }
    },
    destroyed () {
    },
    mounted () {
    },
    components: {
    },
    methods: {
      validParams () {
        http.post(config.companyMemberSignParamValid, this.paramInfo).then((d) => {
          console.log('----companyMemberSignParamValid-----', d);
          if (d.code == 0) {
            this.paramInfo.companyId = (d.data || {}).companyId;
            if (this.paramInfo.companyId) {
              this.forbiddenMsg = "";
              this.loading = false;
            } else {
              this.forbiddenMsg = "签约企业不存在";
              this.$toast.fail('签约企业不存在');
            }
          } else {
            this.forbiddenMsg = d.message || "签名验证失败";
            this.$toast.fail(this.forbiddenMsg)
          }
        });
      },
      nextStep () {
        if (this.loading) {
          return;
        }
        if (this.trim(this.forbiddenMsg)) {
          return this.$toast.fail(this.forbiddenMsg);
        }

        if (!this.trim(this.paramInfo.companyId)) {
          return this.$toast.fail('二维码错误，请重新扫码');
        }

        // if (!this.trim(this.userInfo.mobile)) {
        //   return this.$toast.fail('请填写手机号');
        // }

        if (!this.trim(this.userInfo.userName)) {
          return this.$toast.fail('请填写真实姓名');
        }

        if (!this.trim(this.userInfo.idNo)) {
          return this.$toast.fail('请填写身份证号码');
        }

        let signObj = {
          userName: this.userInfo.userName,
          idNo: this.userInfo.idNo,
          mobile: this.userInfo.mobile,
          companyId: this.paramInfo.companyId,
          configId: this.paramInfo.configId
        }

        this.loading = true
        http.post(config.companyMemberHandSign, signObj).then((d) => {
          console.log(d)
          if (d.code == 0) {
            if (d.data.signStatus == 2) {
              const url = "/memberContractSuccess";
              this.$router.push({ path: url });
              return;
            }
            if (!d.data || !d.data.signUrl) {
              return this.$toast.fail("签约地址生成失败，请重试");
            }
            window.location.href = d.data.signUrl;
          } else {
            this.$toast.fail(d.message)
          }
          this.loading = false
        });
      },

      trim (o) {
        if (!o) {
          return ''
        }
        return o.toString().trim()
      }
    },
  }
</script>
<style>
  /deep/ .van-cell.van-field {

    background: #f7f9fb;
    margin-bottom: 3%;
    border-radius: 10px;

    .van-field__label {
      color: #333;
      font-size: 1.05em;
      width: auto;
      padding-right: 2%;
    }

    input {
      color: #666;
      font-size: 1.05em;
    }
  }

  .weiAuthInfo {
    position: relative;
    width: 100%;
    height: 100%;

    .zhezhao {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      z-index: 9999;
      display: inline-block;
      background: rgba(0, 0, 0, 0.4);

      img {
        width: 54px;
        height: 56px;
        display: block;
        margin: 76% auto;
      }
    }

    .protocolText {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: #fff;
      overflow-y: auto;
      padding: 0.466667rem 0.666667rem;
      box-sizing: border-box;
      line-height: 0.6rem;
      z-index: 9999;
      text-align: left;
      color: #333333;

      .title {
        font-size: 36px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        line-height: 54px;
        text-align: center;
      }

      .name {
        font-size: 30px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        line-height: 90px;
      }

      .haveRead {
        width: 70%;
        margin: 0 auto;
        margin-top: 30px;
        height: 42px;
        line-height: 43px;
        text-align: center;
        font-size: 1.6em;
        font-family: PingFang SC;
        font-weight: 400;
        color: #fff;
        background-color: #53b7f6;
      }
    }

    .personInfoContainer {
      width: 100%;
      height: 100%;

      .idCard {
        width: 100%;
        margin: 0 auto;
        background-color: #fff;
        padding: 2em;
        box-sizing: border-box;
        border-radius: 20px;

        .name {
          width: 100%;
          text-align: center;
          font-size: 1.3em;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: #333;
        }

        .idcodeimg {
          width: 100%;
          height: 100%;
          margin-top: 27px;
          display: flex;
          justify-content: space-between;

          .codeleft {
            width: 45%;
            height: 7.5em;
            border-radius: 10px;
            border: 1px solid #21aaff;
          }

          .coderight {
            width: 45%;
            height: 7.5em;
            border-radius: 10px;
            border: 1px solid #21aaff;
          }

          img {
            width: 100%;
            height: 100%;
          }
        }
      }

      .personInfoDetail {
        padding: 5%;

        /deep/ .van-icon-scan {
          font-size: 1.5em;
        }

        .arguments {
          color: #a2a2a2;
          font-size: 1.08em;
          margin-top: 3vh;
          text-align: center;

          a {
            color: #3083ff;
          }
        }

        .main-input {
          width: 100%;
          padding: 10px;
          position: relative;

          .baoguoed {
            position: absolute;
            bottom: 5px;
            right: 5%;
          }
        }
      }

      .buttonContainer {
        width: 90%;
        margin: 0 auto;
        margin-top: 2vh;

        button {
          width: 100%;
        }
      }
    }

    .uploadIdCardPicContainer {
      width: 100%;
      height: 100%;

      .pageTitle {
        width: 100%;
        height: 10%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 1.5em;
        color: #333;
        text-align: center;
        font-weight: 500;
        border-bottom: 1px solid #f3f4f6;
      }

      .uploadContainer {
        width: 100%;
        height: 80%;
        overflow-x: hidden;
        overflow-y: auto;

        .title {
          height: 8%;
          padding: 4% 4% 0;
          width: 100%;
          font-size: 1.2em;
          color: #333;
        }

        .idCardPic {
          width: 100%;
          padding: 6%;

          .uploadNotice {
            color: #999;
            font-size: 1.1em;
            margin-bottom: 1em;
          }

          .imgContent {
            img {
              width: 100%;
            }
          }
        }

        .notice {
          height: 8%;
          padding: 4%;
          width: 100%;
          color: #666;
          display: flex;
          align-items: center;

          img {
            height: 1em;
            width: 1em;
            margin-right: 0.3em;
          }
        }
      }

      .operationContainer {
        width: 100%;
        height: 10%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 4%;

        button {
          width: 100%;
          height: 70%;
        }
      }
    }
  }
</style>
<style>
  .weiAuthInfo .nut-button {
    height: 1.8em !important;
    font-size: 1.8em !important;
    background: #21aaff;
  }

  .weiAuthInfo .nut-textinput-label {
    font-size: 1em;
  }

  .weiAuthInfo .nut-textinput input {
    height: 100% !important;
    min-height: 40px !important;
  }

  .weiAuthInfo .nut-checkbox input:checked {
    background-color: #21aaff !important;
    border-color: #21aaff !important;
  }

  .weiAuthInfo .nut-button[disabled] {
    background: #dadada !important;
    color: #f6f6f6 !important;
  }

  .weiAuthInfo .codeleft .nut-imagepicker .img-list {
    display: inline-block;
    width: 100%;
  }

  .weiAuthInfo .codeleft .nut-imagepicker .img-list .add-icon {
    width: 39%;
    height: 7.3em;
    border: none;
    background: url("https://gsb-zc.oss-cn-beijing.aliyuncs.com//zc_383515910831670212020215324721idCodez.png") no-repeat;
    background-size: 100% 100%;
    z-index: 10000;
    position: absolute;
    top: 6.1em;
    line-height: 7.3em;
  }

  .weiAuthInfo .coderight .nut-imagepicker .img-list {
    display: inline-block;
    width: 100%;
  }

  .weiAuthInfo .coderight .nut-imagepicker .img-list .add-icon {
    background: url("https://gsb-zc.oss-cn-beijing.aliyuncs.com//zc_1585159108359080520202153950805idCodeb.png") no-repeat;
    background-size: 100% 100%;
    width: 39%;
    height: 7.3em;
    border: none;
    z-index: 10000;
    position: absolute;
    top: 6.1em;
    line-height: 7.3em;
  }

  .weiAuthInfo .nut-imagepicker .img-list .img-item a img {
    display: inline-block;
    width: 100%;
    height: 7.3em;
  }

  .weiAuthInfo .nut-imagepicker .img-list .add-icon i {
    display: none;
  }

  .weiAuthInfo .nut-imagepicker .img-list .img-item {
    width: 100%;
    height: 100%;
  }

  .fujian p {
    line-height: 20px;
  }
</style>




// WEBPACK FOOTER //
// src/pages/customiezd/member/sign.vue